class QuotationDetailHeaderView extends InvoiceDetailHeaderView
{
    awakeFromHTML(): void {
        super.awakeFromHTML();
        this.documentNumberLabel.hidden = true;
    }
}
